module.exports = __webpack_public_path__ + "img/osprey.50760d40.png";